import React from 'react';
import { CommonCard } from 'types';
import GenericGrid from '../GenericGrid';
import { PackCardSkeleton } from '../Cards/PackCard/PackCardSkeleton';

export interface ItemsGridProps<I> {
    items: I[];
    isFetching: boolean;
    page?: number;
    staticItems?: React.ReactNode[];
    cardComponent: CommonCard<I>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function ItemsGrid<I>({
    items,
    isFetching,
    page,
    staticItems,
    cardComponent: CardComponent,
}: ItemsGridProps<I>): JSX.Element {
    return (
        <GenericGrid
            items={items}
            cardComponent={CardComponent}
            fallbackComponent={PackCardSkeleton}
            isFetching={isFetching}
            staticItems={staticItems}
            page={page}
        />
    );
}

export default ItemsGrid;
